import React from 'react';
import { Button, Modal, Toast, Badge } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import { wxfx } from '../../utils/wxfx.js';

import './index.less';
import QRimg from './image/QRBG.png';

/**
 * 根据window.devicePixelRatio获取像素比
 */
function DPR() {
    if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
    }
    return 1;
}
/**
 *  将传入值转为整数
 */
function parseValue(value) {
    return parseInt(value, 10);
};
/**
 * 绘制canvas
 */
async function drawCanvas (selector) {
    // 获取想要转换的 DOM 节点
    const dom = document.querySelector(selector);
    // const box = window.getComputedStyle(dom);
    // DOM 节点计算后宽高
    const width = parseValue(dom.offsetWidth);
    const height = parseValue(dom.offsetHeight);
    // 获取像素比
    const scaleBy = DPR();
    // 创建自定义 canvas 元素
    // var canvas = document.createElement('canvas');
    // 设定 canvas 元素属性宽高为 DOM 节点宽高 * 像素比
    // canvas.width = width * scaleBy;
    // canvas.height = height * scaleBy;

    // 获取画笔
    // const context = canvas.getContext('2d');

    // 将所有绘制内容放大像素比倍
    // context.scale(scaleBy, scaleBy);

    let x = width;
    let y = height;

    window.pageYOffset = 0;
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    html2canvas(dom, {
        dpi: scaleBy * 2,
        width: width,
        height: height,
        scale: scaleBy,
        backgroundColor: '#EE5E32',
    }).then(function (data) {
        Toast.hide();
        convertCanvasToImage(data, x ,y);
    })
}

/**
 * 图片转base64格式
 */
function convertCanvasToImage(canvas, x, y) {
    // let image =  document.getElementsByClassName('shareImg')[0]
    let image = new Image();
    let _container = document.getElementsByClassName('InvitationShareImgBG')[0];
    let _body = document.getElementsByClassName('InvitationShareImgBox')[0];
    let _text = document.getElementsByClassName('InvitationShareImgText')[0];
    image.width = x;
    image.height = y;
    image.src = canvas.toDataURL();
    _body.removeChild(_container);
    _body.insertBefore(image, _text);
    // return image;
}


class InvitationShareImg extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            QR: ''
        };
        
    }

    componentDidMount() {
        if(window.location.hash.indexOf('?url=') > -1){
            QRCode.toDataURL(window.location.hash.split('?url=')[1]).then(url => {
                Toast.loading('图片生成中...', 30);
                this.setState({
                    QR: url
                });
            }).catch(err => {
                console.error(err)
                Toast.info('二维码生成失败！请重试',2);
            })
        }
        this.fx();
    }
    
    fx() {
        wxfx({
            title: '加入慧联租车，享”三优租车“服务',
            imgUrl: 'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUFeAc4IdAADrlgkZLDU935.png',
            desc: `您的好友${window.location.hash.split('?url=')[1].split('?mobile=')[1].replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}邀请您加入慧联租车`,
            url: `${window.location.hash.split('?url=')[1]}`
        })
    }
    
    render() {
        let { type } = this.state;
        return (
            <div className="InvitationShareImgBox">
                <div className="InvitationShareImgBG">
                    <img src={QRimg} onLoad={()=>{
                        setTimeout(()=>{
                            drawCanvas('.InvitationShareImgBG')
                        },200)
                    }} />
                    <div>
                        <img src={this.state.QR} />
                        <p>加入慧联租车<br/>享“三优租车”服务</p>
                    </div>
                </div>
                <div className="InvitationShareImgText">邀请码已生成，长按保存专属海报或点击右上角分享给朋友们吧！</div>
            </div>
        );
    }
}

export default InvitationShareImg;


// WEBPACK FOOTER //
// ./src/invitation/shareImg/index.js